import clsx from 'clsx';
import React from 'react';
import Arrow from '../../../assets/icons/arrow-right.svg?react';
import DoubleArrow from '../../../assets/icons/double-arrow-right.svg?react';
import formStyles from './AppTable.module.scss';
import { Chip } from '../pagination/Chip.tsx';

export type PaginationProps = {
  pageSize: number;
  pageSizes: number[];
  currentPage: number;
  numberOfPages: number;
  goToFirstPage: () => void;
  goToPreviousPage: () => void;
  goToNextPage: () => void;
  goToLastPage: () => void;
  goToCertainPage: (value: number) => void;
  changePageSize: (value: number) => void;
  paginationArray: number[];
  numberOfRows: number;
};

export const Pagination = (props: PaginationProps) => {
  const {
    goToPreviousPage,
    goToLastPage,
    goToCertainPage,
    changePageSize,
    currentPage,
    goToNextPage,
    pageSize,
    numberOfPages,
    goToFirstPage,
    paginationArray,
    numberOfRows,
    pageSizes,
  } = props;

  return (
    <div
      className={clsx(formStyles.rowContainer, formStyles.paginationWrapper)}
    >
      <div className={clsx(formStyles.rowContainer)}>
        <div className={formStyles.greyText}>Display</div>
        <div
          style={{ margin: '0 4px', columnGap: 4 }}
          className={clsx(formStyles.rowContainer)}
        >
          {pageSizes.map((value) => (
            <Chip
              value={value.toString()}
              onClickHandler={() => changePageSize(value)}
              isActive={value === pageSize}
            />
          ))}
        </div>
        <div className={formStyles.greyText}>lines per page</div>
      </div>
      <div className={clsx(formStyles.rowContainer, formStyles.columnGap_4)}>
        <div
          style={{ marginTop: -4 }}
          className={clsx(formStyles.rowContainer, formStyles.columnGap_4)}
        >
          <DoubleArrow
            style={{ marginBottom: -2 }}
            onClick={goToFirstPage}
            className={clsx(
              formStyles.revertedArrow,
              currentPage === 1 && formStyles.disabledDoubleArrow,
            )}
          />
          <Arrow
            className={clsx(
              formStyles.revertedArrow,
              currentPage === 1 && formStyles.disabledArrow,
            )}
            onClick={goToPreviousPage}
          />
        </div>
        <div
          style={{ marginTop: -2 }}
          className={clsx(formStyles.rowContainer, formStyles.columnGap_4)}
        >
          {paginationArray.map((number) => (
            <Chip
              value={number.toString()}
              onClickHandler={() => goToCertainPage(number)}
              isActive={number === currentPage}
            />
          ))}
        </div>
        <div className={clsx(formStyles.rowContainer, formStyles.columnGap_4)}>
          <Arrow
            className={clsx(
              formStyles.pointer,
              currentPage === numberOfPages && formStyles.disabledArrow,
            )}
            onClick={goToNextPage}
          />
          <DoubleArrow
            style={{ marginTop: -1 }}
            className={clsx(
              formStyles.pointer,
              currentPage === numberOfPages && formStyles.disabledDoubleArrow,
            )}
            onClick={goToLastPage}
          />
        </div>
      </div>
      <div className={clsx(formStyles.text, formStyles.greyText)}>
        Number of rows: {numberOfRows}
      </div>
    </div>
  );
};
